app.controller("ChangeImageFromAdminController", ["$scope", "$state", "$http", "$uibModal", "fileReader", "AuthService", "$uibModalInstance", "toastr", "user",
    function ($scope, $state, $http, $uibModal, fileReader, AuthService, $uibModalInstance, toastr, user) {

        $scope.disabled = false;

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.uploadImage = function (files) {
            $scope.image = files[0];
            $scope.fileName = $scope.image.name;
            fileReader.readAsDataUrl($scope.image, $scope).then(function (src) {
                $scope.imageSrc = src;
            })
        };

        $scope.changeImage = function () {
            if ($scope.image) {
                var fd = new FormData();
                $scope.disabled = true;
                fd.append('image', $scope.image);
                fd.append('user', user._id);
                $http.post('/file/image/update', fd, {
                    headers: {'Content-Type': undefined}
                }).then(function (response) {
                    toastr.success('პროფილის სურათი შეცვლილია');
                    $uibModalInstance.close(response.data);
                    $scope.disabled = false;
                })
            }
        };
    }
]);